import type { CSSProperties } from 'react';
import type { CellShape, NoteColors, NoteId } from '../types';
import { NOTE_LABELS } from '../types';

interface Props {
  note: NoteId;
  colors: NoteColors;
  shape: CellShape;
  active: boolean;
  compact?: boolean;
  variant?: 'default' | 'melody';
  disabled?: boolean;
  onClick: () => void;
}

export function NoteCell({
  note,
  colors,
  shape,
  active,
  compact,
  variant = 'default',
  disabled = false,
  onClick,
}: Props) {
  const color = colors[note];
  const isRest = note === 'rest';
  const isMelody = variant === 'melody';

  return (
    <button
      type="button"
      className={[
        'note-cell',
        `note-cell--${shape}`,
        compact ? 'note-cell--compact' : '',
        active ? 'note-cell--active' : '',
        isRest ? 'note-cell--rest' : '',
        isMelody ? 'note-cell--melody' : '',
      ]
        .filter(Boolean)
        .join(' ')}
      onClick={onClick}
      disabled={disabled}
      aria-label={`${NOTE_LABELS[note]}${active ? ', sonando' : ''}`}
      style={
        {
          '--note-color': color,
          '--halo-color': `${color}66`,
        } as CSSProperties
      }
    >
      {!isMelody && <span className="note-cell__halo" aria-hidden="true" />}
      <span className="note-cell__body" aria-hidden="true" />
      {!isRest && <span className="note-cell__label">{NOTE_LABELS[note]}</span>}
    </button>
  );
}
